import { ChangeEvent, EventHandler, useCallback, KeyboardEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ValidationSubmissionsTableProps } from '../ValidationSubmissionsTable.types'

export const useValidationSubmissionSearch = ({
  queryParams,
  setQueryParams
}: Pick<ValidationSubmissionsTableProps, 'queryParams' | 'setQueryParams'>) => {
  const { t } = useTranslation()

  const [searchValue, setSearchValue] = useState<string>(queryParams.query || '')
  const [searchInputStatusMessage, setSearchInputStatusMessage] = useState<string | undefined>(undefined)

  useEffect(() => {
    setSearchValue(queryParams.query)
  }, [queryParams.query])

  const handleKeyChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setSearchValue(value)

    if ((value?.length === 0 || value?.length > 2) && setSearchInputStatusMessage) {
      setSearchInputStatusMessage(undefined)
    }
  }

  const handleKeyPress: EventHandler<KeyboardEvent<HTMLInputElement>> = useCallback(
    event => {
      if (event.key === 'Enter' && searchValue?.length > 0 && searchValue?.length < 3) {
        setSearchInputStatusMessage(t('typography.searchWithMinimum3Characters'))
      }

      if (event.key === 'Enter' && (searchValue?.length === 0 || searchValue?.length > 2)) {
        setQueryParams({
          query: (event.target as HTMLInputElement).value.trim()
        })
      }
    },
    [searchValue?.length, setQueryParams, t]
  )

  const handleClearValue = useCallback(() => {
    setSearchValue('')
    setQueryParams({ query: undefined })
    setSearchInputStatusMessage(undefined)
  }, [setQueryParams])

  return {
    searchValue,
    handleKeyChange,
    handleKeyPress,
    handleClearValue,
    searchInputStatusMessage
  }
}
